// Official Saudi government service links used by CARTAL.
// These are kept in a single configuration module so they can be
// updated in one place if the government portals change URLs — no
// component should hardcode these values inline.
//
// Optional overrides can be injected at build time via env vars
// (REACT_APP_GOV_LINK_TRAFFIC_FINES, REACT_APP_GOV_LINK_VEHICLE_REGISTRATION)
// so ops can rotate URLs without a code change.

const env = (typeof process !== "undefined" && process.env) || {};

export const GOV_LINKS = {
  // Absher — Pay traffic violations (سداد المخالفات المرورية)
  trafficFines:
    env.REACT_APP_GOV_LINK_TRAFFIC_FINES ||
    "https://www.absher.sa/wps/portal/individuals/eServicesHome/violations",

  // Absher — Renew vehicle registration / Istimara (تجديد رخصة السير - الاستمارة)
  vehicleRegistration:
    env.REACT_APP_GOV_LINK_VEHICLE_REGISTRATION ||
    "https://www.absher.sa/wps/portal/individuals/eServicesHome/renewVehicleRegistration",
};
